<template>
  <div id="app">
    <IntroductionHeader />
    <!-- Check form -->
    <template>
      <div class="curved-bg">
        <div class="curved"></div>
      </div>
      <div class="container max-w-5xl px-4 mx-auto curved-container">
        <div class="px-0 mx-2 mt-2 mb-10 text-center sm:px-10 text-md">
          <div class="w-10/12 mx-auto sm:w-12/12">
            <Notice class="rounded-lg" text="To be eligible for our credit card, you must be over 18 and be a UK resident."></Notice>
          </div>
        </div>
        <div class="p-12 mt-2 rounded-lg shadow-full-short ">
          <AboutYourself/>
        </div>
        <div class="p-12 mt-10 rounded-lg shadow-full-short">
          <WhereYouLive/>
        </div>
        <div class="p-12 mt-10 rounded-lg shadow-full-short">
          <WorkAndFinances/>
        </div>
        <div class="pl-6 pr-6 mt-10 rounded-lg">
          <KeepInTouch/>
        </div>
        <div class="p-6 rounded-lg">
          <TermsAndConditions/>
        </div>
        <div class="flex justify-center p-6">
          <button @click="submit()" class="w-full px-4 py-2 text-xl font-semibold text-white rounded-full shadow pol-button sm:w-3/6 hover:bg-polred-dark bg-polred focus:shadow-outline focus:outline-none" type="button">
            Check now
            <p class="text-sm">This won't affect your credit rating</p>
          </button>
        </div>
      </div>
      <div v-if="debug" class="h-screen p-4 bg-gray-100 debug-object">
        <h1 class="mb-2 text-xl font-semibold">✨ Live State</h1>
        <pre>{{ this.$store.state }}</pre>
      </div>
    </template>
    <Footer/>
  </div>
</template>

<script>

import { mapFields } from 'vuex-map-fields'

import IntroductionHeader from '@/v2/components/headers/IntroductionHeader'
import Notice from '@/v2/components/elements/Notice'
import AboutYourself from '@/v2/components/blocks/StandardFlow/AboutYourself'
import WhereYouLive from '@/v2/components/blocks/StandardFlow/WhereYouLive'
import WorkAndFinances from '@/v2/components/blocks/StandardFlow/WorkAndFinances'
import KeepInTouch from '@/v2/components/blocks/StandardFlow/KeepInTouch'
import TermsAndConditions from '@/v2/components/blocks/TermsAndConditions'
import Footer from '@/v2/components/Footer'

import mixins from '@/v2/mixins'

import '@/v2/assets/css/app.css'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'Home',
  mixins: [mixins],
  components: {
    IntroductionHeader,
    Notice,
    AboutYourself,
    WhereYouLive,
    WorkAndFinances,
    KeepInTouch,
    TermsAndConditions,
    Footer
  },
  created () {
    
    let urlParams = new URLSearchParams(window.location.search)
    
    if (urlParams.has('source') && urlParams.get('source').length > 0) {
      if (urlParams.get('source') === 'CM01') {
        this.sourcecode = 'PCM'
      } 
      else {
        this.sourcecode = urlParams.get('source')
      }      
    }

    if (urlParams.has('campaign') && urlParams.get('campaign').length > 0) {
      this.campaign = urlParams.get('campaign')
    }

    if (urlParams.has('selection') && urlParams.get('selection').length > 0) {
      this.productId = urlParams.get('selection')
    }

    if (urlParams.has('polorig') && urlParams.get('polorig').length > 0) {
      if (!urlParams.has('source') || (urlParams.has('source') && urlParams.get('source').length <= 0)) {
        this.sourcecode = "";
      }
      this.fadcode = urlParams.get('polorig')
    }

    if (urlParams.has('debug') && process.env.env !== 'production') {
      this.debug = urlParams.get('debug')
    }
    
  },
  computed : {
    ...mapFields([
      'sourcecode',
      'productId',
      'fadcode',
      'internal.outcome',
      'internal.campaign'
    ])
  },
  data() {
    return {
      debug: false
    }
  }
}
</script>

<style>

</style>
